import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useResendVerificationEmail } from '~/api/auth';
import { ButtonLink, Text } from '~/components';
import { toast } from '~/utils/toast';

import { textMediumStyle, textStyle } from './ResendVerificationEmail.css';

type Props = {
  emailAddress: string;
};

export const ResendVerificationEmail = ({ emailAddress }: Props) => {
  const mutation = useResendVerificationEmail();
  const [secondsUntilRetry, setSecondsUntilRetry] = useState(0);

  const { t } = useTranslation(['auth']);

  const resendVerificationEmail = () =>
    mutation.mutate(
      { emailAddress },
      {
        onSuccess: () => {
          setSecondsUntilRetry(15);

          const intervalId = setInterval(
            () =>
              setSecondsUntilRetry((seconds) => {
                if (seconds === 1) clearInterval(intervalId);
                return seconds - 1;
              }),
            1000,
          );
        },
        onError: () => toast.danger({ description: t('auth:resendVerificationEmail.error') }),
      },
    );

  if (secondsUntilRetry > 0) {
    return (
      <Text className={textStyle}>
        <Trans
          components={{ bold: <span className={textMediumStyle} /> }}
          i18nKey={'auth:resendVerificationEmail.sent'}
          values={{ emailAddress, seconds: secondsUntilRetry }}
        />
      </Text>
    );
  }

  return (
    <Text className={textStyle}>
      <Trans
        components={{
          button: <ButtonLink loading={mutation.isPending} onClick={resendVerificationEmail} />,
        }}
        i18nKey="auth:resendVerificationEmail.send"
      />
    </Text>
  );
};
